"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DropdownButton_1 = require("./DropdownButton");
exports.default = DropdownButton_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/DropdownButton/index.js
// module id = 1768
// module chunks = 8